module.exports = __webpack_public_path__ + "assets/img/4_85_big.b9129aa6.jpg";